module.exports = __webpack_public_path__ + "img/room.99c713ad.svg";